import React, { useContext } from "react";

import { RetroLayout } from "components/retrospective/RetroLayout";
import { RetroCard } from "components/retrospective/RetroCard";
import { makeStyles } from "tss-react/mui";
import { Grid, Typography } from "@mui/material";
import { VictoryArea, VictoryAxis, VictoryChart } from "victory";
import { RetroContext } from "components/retrospective/RetrospectiveMain";
import { CHART_PADDING, RETRO_AXIS_STYLE } from "components/charts/chartStyles";
import { formatMonthLabel, normalizeTimeValues } from "logic/Charts";

const PAGE_DATA = {
  title: "Automação & IoT",
  subtitle: "Tecnologia inteligente a seu favor",
  bgGradient: "#4A8DED",
  illustrationSrc: "/static/img/retro2025/automationImg.png",
  bgImage: "/static/img/retro2025/automation.png",
  pageNum: "3",
};

const useStyles = makeStyles()((theme) => ({
  data: {
    flex: 1,
    display: "grid",
    gap: theme.spacing(3),
    paddingTop: theme.spacing(2),
    height: "100%",

    // vertical
    gridTemplateRows: "55% 30%",
    gridTemplateColumns: "repeat(2, 1fr)",

    // horizontal
    "@media (orientation: landscape)": {
      gridTemplateRows: "repeat(2, 1fr)",
      gridTemplateColumns: "2fr 1fr",
    },
  },
  chart: {
    display: "grid",
    gridTemplateColumns: "100%",
    gridTemplateRows: "10% 90%",
    height: "100%",
    width: "100%",
  },
  chartArea: {
    gridRow: "span 1",
  },
  chartCaption: {
    gridRow: "span 1",
  },
}));

export const RetroAutomation = () => {
  const { classes } = useStyles();

  const { dispositivosOnline, monthlyConsumptions } = useContext(RetroContext);

  return (
    <RetroLayout {...PAGE_DATA}>
      <Grid item container className={classes.data}>
        <RetroCard
          variant="dark"
          gridColumnHorizontal="span 1"
          gridRowHorizontal="span 2"
          gridColumnVertical="span 2"
          gridRowVertical="span 1"
        >
          <Grid item container direction="column" className={classes.chart}>
            <Typography
              color="common.white"
              variant="body2"
              align="center"
              className={classes.chartCaption}
            >
              Evolução mensal do consumo
            </Typography>
            <Grid item container className={classes.chartArea}>
              <svg width="0" height="0" viewBox="0 0 0 0">
                <defs>
                  <linearGradient
                    id="autoGrad"
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="244.72"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop
                      offset="0.05"
                      stop-color="#60A5FA"
                      stop-opacity="0.8"
                    />
                    <stop
                      offset="0.95"
                      stop-color="#60A5FA"
                      stop-opacity="0.1"
                    />
                  </linearGradient>
                </defs>
              </svg>
              <VictoryChart padding={CHART_PADDING}>
                <VictoryAxis
                  style={RETRO_AXIS_STYLE}
                  tickFormat={formatMonthLabel}
                />
                <VictoryAxis style={RETRO_AXIS_STYLE} dependentAxis />
                <VictoryArea
                  // @ts-expect-error
                  data={monthlyConsumptions}
                  x={({ mes }) => normalizeTimeValues({ time: mes, value: 0 })}
                  y="consumo"
                  style={{
                    data: {
                      stroke: "##60A5FA",
                      fill: "url(#autoGrad)",
                    },
                  }}
                />
              </VictoryChart>
            </Grid>
          </Grid>
        </RetroCard>
        <RetroCard
          variant="light"
          mainInfo="24/7"
          caption="Monitoramento"
          gridColumnHorizontal="span 1"
          gridRowHorizontal="span 1"
          gridColumnVertical="span 1"
          gridRowVertical="span 1"
        />
        <RetroCard
          variant="light"
          mainInfo={dispositivosOnline?.toLocaleString("pt-br") || " - "}
          caption="Dispositivos"
          gridColumnHorizontal="span 1"
          gridRowHorizontal="span 1"
          gridColumnVertical="span 1"
          gridRowVertical="span 1"
        />
      </Grid>
    </RetroLayout>
  );
};
